<template>
	<div>
		<b-form-row>
			<b-form-group label="Inicio" class="col-lg-5 col-6">
				<b-form-datepicker reset-button size="sm" v-model="startDate"/>
			</b-form-group>
			<b-form-group label="Fin"  class="col-lg-5 col-6">
				<b-form-datepicker reset-button size="sm" v-model="endDate" :min="startDate"/>
			</b-form-group>
			<b-form-group label="."  class="col-lg-2 col-12 ">
				<b-button variant="outline-primary" @click="addItem()" :class="{'__shake': ( !$root.isEmpty(startDate) || !$root.isEmpty(endDate)) }">Agregar</b-button>
			</b-form-group>
		</b-form-row>
		<b-form-row>
			<b-col class="col-12">
				<b-table striped hover :items="items" :fields="columns" small class="table-condensed">
					<template v-slot:cell(acciones)="row">
						<b-button size="sm" @click="confirmDelete(row.index)" variant="outline-danger"> <md-icon icon="delete"></md-icon></b-button>
					</template>
					<template v-slot:cell(index)="row">
						{{row.index+1}}
					</template>
					<template v-slot:cell(start)="row">
						{{getDateFormatted(row.item.start)}}
					</template>
					<template v-slot:cell(end)="row">
						{{getDateFormatted(row.item.end)}}
					</template>
				</b-table>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: {
		type: String
	},
	components: { },
	data() {
		let columns = [
			{ key: "index", label: "#" },
			{ key: "start", label: "F. inicio" },
			{ key: "end", label: "F. fin" },
			{ key: "acciones", label: "acciones" },
		];
		return {
			columns:columns,
			items: [],
			startDate: null,
			endDate: null
		};
	},
	computed: {

	},
	methods: {
		getDateFormatted(dateString){
			return moment(dateString).format("DD/MMMM/YYYY");
		},
		setData(items){
			this.items = items;
		},
		getData(){
			return this.items
		},
		confirmDelete(index) {
			this.$bvModal.msgBoxConfirm('¿Esta seguro que desea eliminar este rango de fecha?', {
				title: 'Confirmación eliminación',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'SI, Eliminar!',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false
			})
			.then(value => {
				if(value) this.items.splice(index, 1);
			})
			.catch(err => {
				console.log(err)
			})
		},
		addItem(){
			if(this.$root.isEmpty(this.startDate) || this.$root.isEmpty(this.endDate) ){
				this.$root.showAlert("Complete el rango de fecha",{variant:'danger'})
				return;
			}
			let item = {
				start:this.startDate,
				end:this.endDate,
			}
			this.items.push(item)
			this.startDate = null;
			this.endDate   = null;
		}
	},
	mounted() {
		if(process.env.NODE_ENV != "production"){
			this.items=[{start:"2023-05-05",end:"2023-05-10"}]
		}
	},
	watch: {}
};
</script>

<style>
.stacked-options .multiselect__tag {
	float: left;
}
</style>
